// Email notification service using EmailJS
//
// SETUP INSTRUCTIONS:
// 1. Create a free account at https://www.emailjs.com/
// 2. Add an email service (Gmail, Outlook, etc.) in the EmailJS dashboard
// 3. Create an email template with these variables:
//    - {{to_email}} - Recipient email
//    - {{to_name}} - Recipient name
//    - {{student_name}} - Student who booked
//    - {{student_email}} - Student's email
//    - {{appointment_date}} - Date of appointment
//    - {{appointment_start_time}} - Start time
//    - {{appointment_end_time}} - End time
//    - {{appointment_reason}} - Reason for appointment
// 4. Get your Service ID, Template ID, and Public Key from EmailJS dashboard
// 5. Replace the values below with your credentials
//
// Template example:
// Subject: New Appointment Booking - {{appointment_date}}
// Body:
// Hello {{to_name}},
//
// You have a new appointment booking:
//
// Student: {{student_name}} ({{student_email}})
// Date: {{appointment_date}}
// Time: {{appointment_start_time}} - {{appointment_end_time}}
// Reason: {{appointment_reason}}
//
// Please confirm this appointment with the student.

const EMAILJS_SERVICE_ID = 'service_mrwilleby'; // Replace with your EmailJS service ID
const EMAILJS_TEMPLATE_ID_BOOKING = 'template_booking'; // Replace with your booking template ID
const EMAILJS_PUBLIC_KEY = 'YOUR_PUBLIC_KEY'; // Replace with your EmailJS public key

// Initialize EmailJS (this should be called once in the app)
export const initEmailJS = () => {
  if (window.emailjs) {
    window.emailjs.init(EMAILJS_PUBLIC_KEY);
  }
};

// Send booking notification email
export const sendBookingNotification = async ({
  hostEmail,
  hostName,
  studentName,
  studentEmail,
  date,
  startTime,
  endTime,
  reason
}) => {
  try {
    // Check if EmailJS is loaded
    if (!window.emailjs) {
      console.warn('EmailJS not loaded, skipping email notification');
      return { success: false, error: 'EmailJS not loaded' };
    }

    const templateParams = {
      to_email: hostEmail,
      to_name: hostName,
      student_name: studentName,
      student_email: studentEmail,
      appointment_date: date,
      appointment_start_time: startTime,
      appointment_end_time: endTime,
      appointment_reason: reason || 'No specific reason provided',
      reply_to: studentEmail
    };

    const response = await window.emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID_BOOKING,
      templateParams
    );

    console.log('Email sent successfully:', response);
    return { success: true, response };
  } catch (error) {
    console.error('Error sending email:', error);
    return { success: false, error };
  }
};

// Format time for email display
export const formatTimeForEmail = (time) => {
  if (!time) return '';
  const [hours, minutes] = time.split(':');
  const hour = parseInt(hours, 10);
  const ampm = hour >= 12 ? 'PM' : 'AM';
  const displayHour = hour % 12 || 12;
  return `${displayHour}:${minutes} ${ampm}`;
};

// Format date for email display
export const formatDateForEmail = (dateString) => {
  const date = new Date(dateString + 'T00:00:00');
  return date.toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};
